import React, { useRef, useState } from 'react';
import axios from 'axios';

import debounce from 'debounce';

import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import TextField from '@material-ui/core/TextField'
import { InputAdornment } from '@material-ui/core';

const minPostCodeLength = 5;

const PostCodeInput = ({ postcode, description, label = 'Postcode', textFieldVariant = 'outlined', onChange }) => {
    const postcodeRef = useRef(postcode);
    const [help, setHelp] = useState(description || 'Enter a full postcode');

    const handleChange = debounce(() => {

        if (postcodeRef.current.value.length < minPostCodeLength) return;

        (async () => {
            const { data: { result: valid } } = await axios.get(`https://api.postcodes.io/postcodes/${postcodeRef.current.value}/validate`);
            
            if (valid) {
                const { data: { result: place }} = await axios.get(`https://api.postcodes.io/postcodes/${postcodeRef.current.value}`);
                onChange({...place});
                setHelp(`${place.admin_ward}, ${place.admin_district}, ${place.region}`);
            }
            else {
                setHelp("Keep typing ...");
            }
        })();

    }, 500);

    return (<div>
        <TextField
            inputRef={postcodeRef}
            defaultValue={postcode}
            onChange={handleChange}
            label={label}
            helperText={help}
            placeholder="Postcode"
            variant={textFieldVariant}
            InputProps={{
                startAdornment: <InputAdornment position="start"><GpsFixedIcon /></InputAdornment>
            }}
            fullWidth
        />
    </div>)
};

export default PostCodeInput;